import { createSlice } from '@reduxjs/toolkit';

export const templatesSlice = createSlice({
	name: 'templatesSlice',
	initialState: {
		template: null,
	},
	reducers: {
		setTemplate: (state, action) => {
			state.template = action.payload;
		},
	},
});

export const { setTemplate } = templatesSlice.actions;

export default templatesSlice.reducer;
